import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconTextFormatStrikethrough32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconTextFormatStrikethrough32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M7 6h18v4a1 1 0 1 1-2 0V8h-6v4a1 1 0 1 1-2 0V8H9v2a1 1 0 1 1-2 0zm10 14.5a1 1 0 1 0-2 0V24h-3a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2h-3zM8 15a1 1 0 1 0 0 2h16a1 1 0 1 0 0-2z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconTextFormatStrikethrough32);
